var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoupe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.74796C0 4.64877 4.14877 0.5 9.24796 0.5C14.3474 0.5 18.4959 4.64877 18.4959 9.74796C18.4959 11.991 17.6933 14.05 16.3601 15.653L20.75 20.0428C21.0835 20.376 21.0835 20.9167 20.75 21.2499C20.5832 21.4166 20.3647 21.5 20.1464 21.5C19.9279 21.5 19.7096 21.4166 19.5429 21.2499L15.1531 16.8601C13.5501 18.1933 11.491 18.9959 9.24796 18.9959C4.14877 18.9959 0 14.8474 0 9.74796ZM1.70732 9.748C1.70732 13.9059 5.09008 17.2886 9.24796 17.2886C13.4058 17.2886 16.7886 13.9058 16.7886 9.74796C16.7886 5.59008 13.4058 2.20732 9.24796 2.20732C5.09008 2.20732 1.70732 5.59012 1.70732 9.748Z",
    fill: "#7A858C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoupe);
export default __webpack_public_path__ + "static/media/loupe.2e9d7a29.svg";
export { ForwardRef as ReactComponent };